import { Title } from "@components/_Revamp/Typography/Title.stories";
import { styled } from "@linaria/react";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import { themeDefault } from "src/theme-revamp";
import purpleTick from "@assets/icon/ccp-purple-tick.svg";
import React, { useCallback, useEffect, useRef, useState } from "react";
import InnerContainer from "@components/_Revamp/InnerContainer";
import Lottie from "react-lottie-player";
import animate_logo_json from "@assets/images/singlife-logo-purple.json";
import { SCREEN_SIZE } from "@static/screen-size";
import Button from "@components/_Revamp/Button";
import Modal from "@components/_Revamp/Modal";
import { useHistory, useLocation } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { useAvivaSelector } from "@redux/hook";
import { Helpers, LoadingScreen } from "@utils/helpers";
import LeftHand from "@assets/images/cancer-cover-heart.svg";
import RightHand from "@assets/images/cancer-cover-checklist.svg";
import { css } from "@linaria/core";
import featureImage1 from "@pages/CCP/assets/ccp-feature-icon-1.svg";
import featureImage2 from "@pages/CCP/assets/ccp-feature-icon-2.svg";
import featureImage3 from "@pages/CCP/assets/ccp-feature-icon-3.svg";
import arrowRightImg from "@assets/icon/chevron-right-purple.svg";
import instructionVideo from "@pages/CCP/assets/product-instruction.mp4";
import Link from "@components/_Revamp/Link";
import IconDonwload from "@assets/icon/download-purple.svg";
import { CCP_PRODUCT_SUMMARY } from "@static/staticConstents";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import close from "@assets/icon/close.svg";
import slideImage1 from "@pages/CCP/assets/slide1.png";
import slideImage2 from "@pages/CCP/assets/slide2.png";
import { mask } from "@utils/mask";
import { PRODUCT_CODE_API, postValidateAdviser } from "@api/index";
import { Mapper } from "../ApplicationDetails/FinancialAdviser";
import {
  NotificationBox,
  NotificationContent,
} from "@components/_Revamp/NotificationBox";
import { useDispatch } from "react-redux";
import {
  updateArcCode,
  updateAssignedAgentOption,
  updateFARData,
  updateFinancialAdviser,
  updateFinancialAdviserLink,
  updatePromoCode,
  updateShowArcPage,
} from "@redux/slices/CCP/step6Slice";
import { updateCurrentProductArcStatus } from "@redux/slices/loadingSlice";
import { PLANS, PLANS_NAME } from "@static/config";
import { store } from "@redux/store";
import { updateTransactionId } from "@redux/slices/CCP/step1Slice";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { setQueryString } from "@redux/slices/querySlice";
import { updateUrlParam } from "@redux/slices/MLTC_R3/urlAnalyticSlice";

const features = [
  {
    img: featureImage1,
    title: "Option to seek cancer treatments overseas",
    description: "Your overseas medical claims are covered.",
  },
  {
    img: featureImage2,
    title: "Enhanced medical options for greater control",
    description:
      "Cancer treatments on the Cancer Drug List (CDL) and non-CDL are covered.",
  },
  {
    img: featureImage3,
    title: "Comprehensive support throughout your journey",
    description:
      "Get access to personalised cancer treatments from our trusted medical partners.",
  },
];

const slideImages = [
  {
    url: slideImage1,
    caption: "Slide 1",
  },
  {
    url: slideImage2,
    caption: "Slide 2",
  },
];

function LandingPage() {
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [arcError, setArcError] = useState<boolean>(false);
  const arcValidated = useRef<boolean>(false);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(setQueryString(location.search));
  }, [location.search]);


  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const productData = useAvivaSelector(
    (state) => state.cancerCoverStep1.productinfo
  );
  const transactionId = useAvivaSelector(
    (state) => state.cancerCoverStep1.transactionId
  );
  const [animation, setAnimation] = useState(false);
  const ANIMATE_LOGO_WIDTH =
    screenSize >= SCREEN_SIZE.mobilesUp ? "415px" : "215px";
  const ANIMATE_LOGO_HEIGHT =
    screenSize >= SCREEN_SIZE.mobilesUp ? "407px" : "211px";
  const ANIMATE_LOGO_STYLES: React.CSSProperties = {
    position: "relative",
    zIndex: 1,
    opacity: 1,
    // top: ANIMATE_LOGO_TOP,
    width: ANIMATE_LOGO_WIDTH,
    height: ANIMATE_LOGO_HEIGHT,
  };
  const indicators = (index?: number) => <div className={indicator}></div>;
  const cancerCoverStep3 = useAvivaSelector(
    (state) => state.cancerCoverStep3.underWriting1
  );
  const arcCodefromStore = useAvivaSelector(state=>state.cancerCoverStep6.arcCode)
  console.warn(cancerCoverStep3);

  useEffect(() => {
    // dispatch(getValidationDate());
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  useEffect(() => {
    async function fetcher() {
      LoadingScreen(false);
      setAnimation(true);
      if (!transactionId) {
        let transaction_id = crypto.randomUUID();
        dispatch(updateTransactionId(transaction_id));
      }
    }
    fetcher();

    sessionStorage.removeItem("policyConfirmatio");
  }, []);

  useEffect(() => {
    const leftHand = document.querySelector("#left-hand") as HTMLElement;
    const rightHand = document.querySelector("#right-hand") as HTMLElement;
    if (leftHand && !leftHand.classList.contains("leftHandAnimation")) {
      leftHand.classList.add("leftHandAnimation");
    }
    if (rightHand && !rightHand.classList.contains("rightHandAnimation")) {
      rightHand.classList.add("rightHandAnimation");
    }
    return () => {
      const leftHand = document.querySelector("#left-hand") as HTMLElement;
      const rightHand = document.querySelector("#right-hand") as HTMLElement;
      if (leftHand && leftHand.classList.contains("leftHandAnimation")) {
        leftHand.classList.remove("leftHandAnimation");
      }
      if (rightHand && rightHand.classList.contains("rightHandAnimation")) {
        rightHand.classList.remove("rightHandAnimation");
      }
    };
  }, [animation]);

  const analyticUrlParams = useAvivaSelector(
      (state) => state.urlAnalytic.param
    );

  useEffect(() => {
    const urlParams: URLSearchParams = Helpers.getURLSearchParams();
    const arcCode: string =
      urlParams.get("arc") ||
      store.getState().loading.arcCodeRecieved?.ccp.arcCode ||
      ""; // TODO check with ben on the subsequent purchase post clearing entire store after completing prior pruchase
      const promoCode: string =
      urlParams.get("pm")?.replace(/ /g, "+") || 
      "";       
    if (!arcCode) return;
    const validateFarCode = async (option?: HTMLDivElement) => {
      try {
        const payload = {
          agentCode: arcCode,
          promoCode: promoCode,
          clientNo: "",
          loggedInUserId: 0,
          loginUser: "",
          requesterClientNumber: "",
          sourceSystem: "CCP",
          agentSelectedType: "USER_PREFERRED",
          customerId: null,
        };
        const { data } = await postValidateAdviser(
          arcCode,
          PRODUCT_CODE_API.CANCER_COVER,
          payload
        );
        if (
          data?.data &&
          data?.data?.fullName &&
          data?.data?.agentTerminatedFlag !== "Y"
        ) {
          //update the store
          if (data?.data?.fullName) {
            data.data.fullName = mask(data?.data?.fullName);
          }
          dispatch(updatePromoCode(promoCode))
          dispatch(updateFARData({ code: arcCode }));
          dispatch(updateArcCode(arcCode))
          dispatch(updateAssignedAgentOption("own-adviser"));
          dispatch(updateFinancialAdviser(data));
          dispatch(updateFinancialAdviserLink(true));
          dispatch(updateShowArcPage(true));
          dispatch(
            updateCurrentProductArcStatus({
              PLAN_NAME: PLANS_NAME.CANCER_COVER_PLUS,
              values: {
                arcCode,
                isValid: true,
              },
            })
          );
          dispatch(updateUrlParam({ ...analyticUrlParams, arc: arcCode, pm: promoCode }));
        } else {
          setArcError(true);
          dispatch(
            updateCurrentProductArcStatus({
              PLAN_NAME: PLANS_NAME.CANCER_COVER_PLUS,
              values: {
                arcCode,
                isValid: false,
              },
            })
          );
          dispatch(updateUrlParam({ ...analyticUrlParams, arc: "", pm: "" }));
        }
      } catch (e) {
        //TODO update the error screen route
        setArcError(true);
      }
    };
    if (arcCode && !arcValidated.current) {
      arcValidated.current = true;
      validateFarCode();
    }
  }, []);

  //AA Page Loading
  useEffect(() => {
    trackOnLoad();
  }, []);

  return (
    <>
      <BGSpinner>
        <Lottie
          loop={true}
          animationData={animate_logo_json}
          play={true}
          style={ANIMATE_LOGO_STYLES}
        ></Lottie>
      </BGSpinner>
      <HealthMainContainer stepList={[]}>
        <HeaderText>
          Singlife <span>{productData?.productName}</span>
        </HeaderText>
        <Title variant="title" align="left">
          Get a quote within minutes
        </Title>
        <ListedFeatures>
          <li>
            <img src={purpleTick} alt="list-icon" />
            <span>
              <b>Covers outpatient cancer drug treatment and services</b> -
              Including Proton Beam Therapy and Cell, Tissue and Gene Therapy.
            </span>
          </li>
          <li>
            <img src={purpleTick} alt="list-icon" />
            <span>
              <b>As-charged coverage of up to S$1.5 mil</b> - Have greater peace
              of mind knowing your out-of-pocket expenses are significantly
              reduced.
            </span>
          </li>
          <li>
            <img src={purpleTick} alt="list-icon" />
            <span>
              <b>Easy and fast application</b> - Sign up by answering 3 simple
              health questions with no medical check-up needed.
            </span>
          </li>
        </ListedFeatures>
        <InnerContainer className={InnerContainerStyle}>
          <MidTitle>
            What you’ll appreciate about Singlife Cancer Cover
            <br />
            Plus II
          </MidTitle>
          <div className={featureList}>
            {features.map((item) => {
              return (
                <div className={feature}>
                  <img src={item.img} alt="feature-icon" />
                  <div className={featureHeader}>{item.title}</div>
                  <div className={featureDes}>{item.description}</div>
                </div>
              );
            })}
          </div>
          <div
            className={findoutText}
            onClick={() => {
              trackOnCTA({
                ctaText: "Find out how Singlife Cancer Cover Plus II works",
                ctaType: "qb:link",
              });
              setShowModal(true);
            }}
          >
            Find out how Singlife Cancer Cover Plus II works
            <img src={arrowRightImg} alt="how" />
          </div>
        </InnerContainer>
        <InnerContainer className={slideContainer}>
          <MidTitle>
            Here's how it works with additional cancer treatment
          </MidTitle>
          <p className={smallTitle}>
            In 2022, the Ministry of Health (MOH) introduced a Cancer Drug List
            (CDL) of more cost-effective cancer treatments for patients.
            Singlife Cancer Cover Plus II gives you greater control over your
            medical options as it covers cancer treatments both on the CDL and
            non-CDL.
          </p>
          <Slide arrows={false} indicators={indicators} autoplay={false}>
            {slideImages.map((slideImage, index) => (
              <div className={slideImageStyle} key={index}>
                <img src={slideImage.url} alt="slide" />
              </div>
            ))}
          </Slide>
          <div className={readSummaryStyle}>
            <Link
              onClick={() => {
                trackOnCTA({
                  ctaText: "Read our Product Summary",
                  ctaType: "qb:link",
                  type: "track_document_download",
                });
              }}
              fontSize={14}
              fontSizeTablet={14}
              color="#883E89"
              text="Read our Product Summary"
              target="_blank"
              rel="noopener noreferrer"
              url={CCP_PRODUCT_SUMMARY}
              icon={IconDonwload}
              iconSize="xsm"
            />
          </div>
        </InnerContainer>
        <ButtonContainer>
          <Button
            variant="default"
            hoverBgColor={themeDefault.colors.primary}
            hoverTextColor={themeDefault.colors.white}
            label="Get my quote"
            onClick={() => {
              trackOnCTA({
                ctaText: "Get my quote",
                ctaType: "qb:link",
              });
              history.push(ROUTE_PATH.CANCER_COVER_BASIC_INFO);
            }}
          />
        </ButtonContainer>
      </HealthMainContainer>
      {showModal && (
        <Modal
          className={modalPadding}
          show={showModal}
          onClose={() => {
            setShowModal(false);
          }}
        >
          <Title
            variant="title"
            align="center"
            color={themeDefault.colors.primary}
          >
            Find out how Singlife Cancer Cover Plus II works
          </Title>
          <div>
            <video src={instructionVideo} width={618} height={399} autoPlay />
          </div>
        </Modal>
      )}
      {animation && (
        <HandJarContainer>
          <img id="left-hand" src={LeftHand} alt="left-pic" />
          <img id="right-hand" src={RightHand} alt="left-pic" />
        </HandJarContainer>
      )}
      {arcError ? (
        <NotificationBox className={notificationClass}>
          <NotificationContent iconFill={"#990005"}>
            <div>
              <div>
                <b>Incorrect adviser code.</b> Close the browser and try again
                with another code or continue without an adviser code.
              </div>
              <CloseIcon src={close} onClick={() => setArcError(false)} />
            </div>
          </NotificationContent>
        </NotificationBox>
      ) : null}
    </>
  );
}

export default LandingPage;

const BGSpinner = styled.div`
  position: absolute;
  display: none;
  transform: translate(50%, 50%);
  top: 46%;
  opacity: 0.15;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    display: unset;
    top: unset;
    right: 38%;
  }
`;

const notificationClass = css`
  width: unset;
  border-radius: 16px;
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 5;
  font-size: 14px;
  background-color: "#ffe9e9";
  color: "#990005";
  font-weight: 500;
  border-left: 4px solid "#990005";
  b {
    display: contents;
  }
  div {
    display: flex;
    gap: 8px;
    width: 100%;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: 450px;
    div {
      max-width: unset;
    }
  }
`;

const HandJarContainer = styled.div`
  display: none;
  @media screen and (min-width: 1358px) {
    display: unset;
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    img:nth-child(1) {
      position: absolute;
      top: 120px;
      transform-origin: 0% 0%;
      transform: translateX(-100%);
    }

    .leftHandAnimation {
      animation: lefttanimation 1s ease-in 2s forwards;
      @keyframes lefttanimation {
        0% {
          transform: translateX(-100%);
        }
        60% {
          transform: translateX(-50%);
        }
        100% {
          transform: translateX(0);
        }
      }
    }

    img:nth-child(2) {
      transform-origin: 100% 100%;
      position: absolute;
      top: 500px;
      right: 0px;
      transform: translateX(100%);
    }
    .rightHandAnimation {
      animation: rightAnimation 1s ease-in 2s forwards;

      @keyframes rightAnimation {
        0% {
          transform: translateX(100%);
        }
        60% {
          transform: translateX(50%);
        }
        100% {
          transform: translateX(0);
        }
      }
    }
    img:nth-child(3) {
      transform-origin: 0% 0%;
      position: absolute;
      left: 5%;
      bottom: -270px;
    }
    .jarAnimation {
      animation: jaranimation 1s ease-in 2s forwards;

      @keyframes jaranimation {
        0% {
          bottom: -270px;
        }
        60% {
          bottom: 15px;
        }
        100% {
          bottom: 0px;
        }
      }
    }
  }
`;

const InnerContainerStyle = css`
  padding: 16px;
  @media screen and (min-width: ${`${SCREEN_SIZE.mobilesUp}px`}) {
    padding: 36px;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 64px;
  margin-bottom: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  button {
    cursor: pointer;
    max-width: 327px;
    width: 100%;
  }
  @media screen and (min-width: ${`${SCREEN_SIZE.mobilesUp}px`}) {
    flex-direction: row;
    button {
      cursor: pointer;
      max-width: 203px;
      width: 100%;
    }
  }
`;

const HeaderText = styled.h1`
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 56px */
  letter-spacing: 0.75px;
  margin-bottom: 24px;
  span {
    color: #883E89;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 40px;
  }
`;

const MidTitle = styled.h3`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #434343;
  padding-left: 22px;
  position: relative;
  margin: 8px;

  &:before {
    background-color: #883e89;
    border-radius: 4px;
    content: "";
    width: 6px;
    height: 100%;
    position: absolute;
    left: 0;
  }
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
    margin: 0px;
  }
`;

const smallTitle = css`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19.6px;
  color: #434343;
  padding: 28px 0 24px 0;
`;

const CloseIcon = styled.img`
  cursor: pointer;
  width: 14px;
  height: 14px;
  transform: rotate(90deg);
  transition: all 0.8s ease-out 0s;

  &:hover {
    transform: rotate(360deg);
    transition: all 1s ease-out 0s;
  }
`;

const ListedFeatures = styled.ul`
  list-style: none;
  list-style-image: url(${purpleTick});
  font-size: 14px;
  font-weight: 500;
  flex-direction: column;
  display: flex;
  gap: 14px;
  margin-bottom: 26px;
  margin-top: 24px;
  li {
    display: flex;
    align-items: center;
    gap: 16px;
    img {
      display: flex;
      align-self: start;
    }
    b {
      font-weight: 600;
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    li {
      img {
        display: unset;
        align-self: unset;
      }
    }
  }
`;

const modalPadding = css`
  .modal-body {
    padding: 24px 16px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      padding: 36px;
    }
  }
`;

const featureList = css`
  display: flex;
  gap: 48px;
  padding: 28px 0 24px 0;
  flex-wrap: wrap;
  margin-top: 32px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    gap: 24px;
  }
`;

const feature = css`
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 24px;
  position: relative;
  flex-grow: 1;
  width: 100%;
  height: auto;
  img {
    position: absolute;
    top: -28px;
    left: 22px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    height: 154px;
    width: 24%;
    padding: 28px 24px 24px 24px;
    img {
      position: absolute;
      top: -22px;
      left: 22px;
    }
  }
`;

const featureHeader = css`
  font-weight: 600;
  margin-bottom: 8px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-bottom: 16px;
    min-height: 64px;
  }
`;

const featureDes = css`
  font-size: 14px;
`;

const findoutText = css`
  color: #883E89;
  text-decoration: underline;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  cursor: pointer;
  margin: 16px 0 16px 0;
  img {
    margin-left: 24px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin: 16px 0 32px 0;
  }
`;

const slideContainer = css`
  margin-top: 32px;
  padding: 24px;
  h3 {
    margin: 0;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 36px;
  }
`;

const slideImageStyle = css`
  border-radius: 12px;
  border: 1px solid #f5f5f5;
  img {
    width: 100%;
    height: auto;
    pointer-events: none;
    cursor: default;
  }
`;

const readSummaryStyle = css`
  text-align: center;
  margin-top: 16px;
`;

const indicator = css`
  background-color: #434343;
  height: 4px;
  width: 16px;
  margin: 0 4px;
  opacity: 0.2;
  border-radius: 8px;
  cursor: pointer;
  transition: all 1s linear;
  &.active {
    background-color: #883E89;
    width: 24px;
    opacity: 1;
  }
  &:hover {
    height: 8px;
    width: 24px;
  }
`;
